import { createAsyncThunk } from "@reduxjs/toolkit";
import { dataServer } from "~/constants";
import { setAppData } from "~/slices/appSlice";

export const fetchAppData = createAsyncThunk(
  "app/fetchAppData",
  async (_, { dispatch, getState }) => {

    const response = await fetch(dataServer + "appdata");
    const data = await response.json();
    
    return data;
  }
);
